import axios from 'axios';

const API_BASE_URL = '';
const instance = axios.create({
  baseURL: API_BASE_URL,
});
instance.interceptors.request.use(
  (config) => {
    const authToken = sessionStorage.getItem('token');
    if (authToken && authToken!="undefined") {
      config.headers['authToken'] = JSON.parse(authToken);
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default instance;
